'use client';
import { useTranslations } from 'next-intl';
import useCompany from '@/app/hooks/useCompany';
import ContactForm from './ContactForm';
import LocationMap from './LocationMap';

export default function Hero() {
  const t = useTranslations('Contact');
  const { company } = useCompany();

  return (
    <div className='mb-10 mt-16 px-4 md:px-20 text-start'>
      <div className='flex flex-col justify-start md:items-center'>
        <h2 className='text-sm md:text-[16px] leading-none mt-4 md:mt-0'>
          {t('contact_us')} <br />
        </h2>
        <h1 className='text-xl md:text-4xl font-semibold leading-none text-start mt-6'>
          {t('title')} <br />
        </h1>
        <h2 className='text-sm md:text-[16px] leading-none mt-4'>
          {t('subtitle')} <br />
        </h2>
      </div>
      <div className='flex flex-col md:flex-row justify-start mt-4 md:mt-14 md:gap-16'>
        <ContactForm />
        <div className='flex-1'>
          <h1 className='text-xl text-start font-semibold mt-10'>
            {t('also_contact')} <br />
          </h1>
          <div className="mt-4 flex flex-col gap-2">
            <h4 className='underline font-medium'>{company?.phone_numbers[0]}</h4>
            <h4 className='underline font-medium'>{company?.phone_numbers[1]}</h4>
            <h4 className='underline font-medium'>{company?.emails[0]}</h4>
          </div>
        </div>
      </div>
      <div className='mt-4'>
        <LocationMap />
      </div>
    </div>
  );
}
